import { ProductRequestModel } from "libs/models/products";
import { ValidationModel } from "libs/models/validate-model";
import { RedemptionChannelStore } from "store/slices/redemption-channel";
import { ProductsStore } from "store/slices/products";
import translate from "utils/translations";
import { decimalNumberRegex, numberRegex, passwordRegex } from "utils/regex";

export const validateEditProductState = (
  state: ProductsStore
): ValidationModel<ProductRequestModel> => {
  let validationModel = {} as ValidationModel<ProductRequestModel>;
  if (!state.isValidating) {
    return validationModel;
  }
  if (!state.updatedProductData.name) {
    validationModel.name = translate("Required_Field", "Required Field");
  }
  if (
    state.updatedProductData.name &&
    state.updatedProductData.name.length > 200
  ) {
    validationModel.name = translate("Long_Text", "Text is too long");
  }
  if (
    state.updatedProductData.name &&
    state.updatedProductData.name !== "" &&
    state.updatedProductData.name.length < 2
  ) {
    validationModel.name = translate("Short_Text", "Text is too short");
  }
  if (!state.updatedProductData.validityPeriod) {
    validationModel.validityPeriod = translate(
      "Required_Field",
      "Required Field"
    );
  }

  if (
    state.updatedProductData.validityPeriod !== undefined &&
    !numberRegex.test(state.updatedProductData.validityPeriod.toString())
  ) {
    validationModel.validityPeriod = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  if (
    state.updatedProductData.clickingFees !== undefined &&
    !decimalNumberRegex.test(state.updatedProductData.clickingFees.toString())
  ) {
    validationModel.clickingFees = translate(
      "Invalid_Data_Text",
      "Invalid Data TODO"
    );
  }
  return validationModel;
};
